import { ILoadingCellRendererParams } from 'ag-grid-community';

const LoadingOverlayComponent: React.FC<ILoadingCellRendererParams & { loadingMessage: string }> = ({
  loadingMessage = 'Loading...',
}) => {
  return (
    <div className="ag-custom-loading-cell">
      <span>{loadingMessage}</span>
    </div>
  );
};

export default LoadingOverlayComponent;
